import { baseQuery } from "src/store/helpers/baseQuery";

import { createApi } from "@reduxjs/toolkit/query/react";

import rtkClient from "./rtkClient";

export const filesApi = createApi({
    reducerPath: "filesApi",
    tagTypes: ["Files"],
    keepUnusedDataFor: 300,
    baseQuery,
    endpoints: (builder) => ({
        deleteFile: rtkClient.deleteFile(builder),
        uploadFile: rtkClient.uploadFile(builder),
        updateFile: rtkClient.updateFile(builder),
        updateFileMetadata: rtkClient.updateFileMetadata(builder),
        updateFileRollout: rtkClient.updateFileRollout(builder),
        getFiles: rtkClient.getFiles(builder),
    }),
});

export const {
    useDeleteFileMutation,
    useUploadFileMutation,
    useUpdateFileMutation,
    useUpdateFileMetadataMutation,
    useUpdateFileRolloutMutation,
    useGetFilesQuery,
    useLazyGetFilesQuery,
    usePrefetch,
} = filesApi;
